/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { B2BCostCenter } from './B2BCostCenter';
import {
    B2BCostCenterFromJSON,
    B2BCostCenterFromJSONTyped,
    B2BCostCenterToJSON,
} from './B2BCostCenter';
import type { B2BUnit } from './B2BUnit';
import {
    B2BUnitFromJSON,
    B2BUnitFromJSONTyped,
    B2BUnitToJSON,
} from './B2BUnit';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * Representation of an Order History
 * @export
 * @interface OrderHistory
 */
export interface OrderHistory {
    /**
     * Code of Order History
     * @type {string}
     * @memberof OrderHistory
     */
    code?: string;
    /**
     * Status of Order History
     * @type {string}
     * @memberof OrderHistory
     */
    status?: string;
    /**
     * Status display
     * @type {string}
     * @memberof OrderHistory
     */
    statusDisplay?: string;
    /**
     * Date of placing order
     * @type {Date}
     * @memberof OrderHistory
     */
    placed?: Date;
    /**
     * Guest user identifier
     * @type {string}
     * @memberof OrderHistory
     */
    guid?: string;
    /**
     * 
     * @type {Price}
     * @memberof OrderHistory
     */
    total?: Price;
    /**
     * 
     * @type {B2BCostCenter}
     * @memberof OrderHistory
     */
    costCenter?: B2BCostCenter;
    /**
     * 
     * @type {B2BUnit}
     * @memberof OrderHistory
     */
    orgUnit?: B2BUnit;
    /**
     * Purchase order number
     * @type {string}
     * @memberof OrderHistory
     */
    purchaseOrderNumber?: string;
    /**
     * 
     * @type {User}
     * @memberof OrderHistory
     */
    orgCustomer?: User;
}

/**
 * Check if a given object implements the OrderHistory interface.
 */
export function instanceOfOrderHistory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderHistoryFromJSON(json: any): OrderHistory {
    return OrderHistoryFromJSONTyped(json, false);
}

export function OrderHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDisplay': !exists(json, 'statusDisplay') ? undefined : json['statusDisplay'],
        'placed': !exists(json, 'placed') ? undefined : (new Date(json['placed'])),
        'guid': !exists(json, 'guid') ? undefined : json['guid'],
        'total': !exists(json, 'total') ? undefined : PriceFromJSON(json['total']),
        'costCenter': !exists(json, 'costCenter') ? undefined : B2BCostCenterFromJSON(json['costCenter']),
        'orgUnit': !exists(json, 'orgUnit') ? undefined : B2BUnitFromJSON(json['orgUnit']),
        'purchaseOrderNumber': !exists(json, 'purchaseOrderNumber') ? undefined : json['purchaseOrderNumber'],
        'orgCustomer': !exists(json, 'orgCustomer') ? undefined : UserFromJSON(json['orgCustomer']),
    };
}

export function OrderHistoryToJSON(value?: OrderHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'status': value.status,
        'statusDisplay': value.statusDisplay,
        'placed': value.placed === undefined ? undefined : (value.placed.toISOString()),
        'guid': value.guid,
        'total': PriceToJSON(value.total),
        'costCenter': B2BCostCenterToJSON(value.costCenter),
        'orgUnit': B2BUnitToJSON(value.orgUnit),
        'purchaseOrderNumber': value.purchaseOrderNumber,
        'orgCustomer': UserToJSON(value.orgCustomer),
    };
}

